import React from 'react';
import { useTranslation } from 'react-i18next';
import './TournamentMatchCard.css';

const TournamentMatchCard = ({ match, onJoin }) => {
  const { t } = useTranslation();

  const gameLabel = match.best_of > 1
    ? `Bo${match.best_of} (${t('tournament.game', 'Game')} ${match.current_game + 1})`
    : '';

  return (
    <div className="tournament-match-card">
      <div className="tournament-match-card__header">
        <span className="tournament-match-card__icon">&#127942;</span>
        <span className="tournament-match-card__title">{t('tournament.matchReady', 'Tournament Match')}</span>
      </div>

      {match.tournament_name && (
        <div className="tournament-match-card__tournament">{match.tournament_name}</div>
      )}

      <div className="tournament-match-card__teams">
        <span className="tournament-match-card__team">{match.team_a_name}</span>
        <span className="tournament-match-card__vs">vs</span>
        <span className="tournament-match-card__team">{match.team_b_name}</span>
      </div>

      {match.best_of > 1 && (
        <div className="tournament-match-card__series">
          {match.team_a_wins} - {match.team_b_wins} {gameLabel && `| ${gameLabel}`}
        </div>
      )}

      <button
        className="tournament-match-card__join"
        onClick={() => onJoin(match.lobby_code)}
      >
        {t('tournament.joinMatch', 'Join Match')}
      </button>
    </div>
  );
};

export default TournamentMatchCard;
